import type { ReactElement } from 'react'
import { useSelector } from 'react-redux'

import { useTranslate } from '../../utils/translate'

type PercentageProps = {
  className?: string
  oldPrice: number
  newPrice: number
}

export default function Percentage({ className, oldPrice, newPrice }: Readonly<PercentageProps>): ReactElement {
  const locale = useSelector<State, string>((state) => state.getIn(['shop', 'locale']).replace('_', '-'))
  const t = useTranslate('shop')

  const percentageAmount = newPrice / oldPrice - 1
  const percentageDisplay = new Intl.NumberFormat(locale, {
    style: 'percent',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(percentageAmount)

  return (
    <div className={className}>
      <span className="visually-hidden">
        {t('components.productComponent.discount.accessibilityLabel', {
          percent: percentageDisplay,
        })}
      </span>
      <span aria-hidden="true" data-testid="product-percentage-badge">
        {percentageDisplay}
      </span>
    </div>
  )
}
